import styled from 'styled-components';

export const ImportCsvStyled = styled.div`
  width: 740px;

  .dark-link,
  .dark-link span {
    transition: all .3s, visibility 0s;
  }
`;

export const FinalStepStyled = styled.div
  .attrs({ className: 'd-f fd-c ai-c jc-c bg-secondary gap-5' })`
  height: 450px;
`;
